<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolHostelManagementSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/hostel-management/hostels",
                title: "Hostels",
                description: "Create and manage school hostels and accommodation details.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/hostel-management/hostel-floors",
                title: "Hostel Floors",
                description: "Organize hostel floors and their accommodation areas.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/hostel-management/hostel-rooms",
                title: "Hostel Rooms",
                description: "Manage hostel rooms and room availability.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/hostel-management/hostel-beds",
                title: "Hostel Beds",
                description: "Track hostel beds and current availability.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/hostel-management/bed-allocations",
                title: "Bed Allocation",
                description: "Assign students to available hostel beds.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Hostel Register",
                description: "Review hostel residents and accommodation assignments.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Visitor Records",
                description: "Record and review visitors to school hostels.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
